import { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import NeutralLabel from 'LuxKit/Label/NeutralLabel'
import config from 'constants/config'

interface Props {
  testId?: string
  depositAmountPercentage?: number
}
function SecureWithDepositTag(props: Props) {
  const { testId, depositAmountPercentage } = props
  if (!config.DEPOSITS_TAGS_ENABLED) {
    return null
  }

  const depositLabel = depositAmountPercentage
    ? (
        <FormattedMessage
          id="xxPTLWw5nWKYSb7-FsdR"
          defaultMessage="Secure with a {percentage}% deposit"
          
          values={{ percentage: depositAmountPercentage }}
        />
      )
    : (
        <FormattedMessage
          id="6Cnf53uqrowISx6k6peC"
          defaultMessage="Secure with a deposit"
          
        />
      )

  return (
    <NeutralLabel data-testid={testId} startIcon={<LineClockDollarIcon />}>
      {depositLabel}
    </NeutralLabel>
  )
}
export default memo(SecureWithDepositTag)
